// extracted by mini-css-extract-plugin
export default {"ButtonMicroWrapper":"SignIn_ButtonMicroWrapper__TFJu4"};